"use client";
import "../../../chunk-MMUBH76A.js";
import { useStore } from "../../stores/useStore.js";
import { useClient } from "./useClient.js";
const useWalletState = () => {
  const client = useClient();
  const selectedWalletId = useStore((state) => state.selectedWalletId);
  const selectedWalletType = useStore((state) => state.selectedWalletType);
  const setStoredSelectedWallet = useStore((state) => state.setSelectedWallet);
  const clearSelectedWallet = useStore((state) => state.clearSelectedWallet);
  const setSelectedWallet = ({ id, type }) => {
    try {
      const validId = client.findWalletId(id, { type: [type] });
      if (validId !== id) {
        clearSelectedWallet();
      } else {
        setStoredSelectedWallet(id, type);
      }
    } catch (e) {
      clearSelectedWallet();
    }
  };
  return {
    selectedWallet: {
      id: selectedWalletId,
      type: selectedWalletType
    },
    setSelectedWallet
  };
};
export {
  useWalletState
};
